import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import UsersSearch from '@sayyesschool/frontend/components/users-search';
import { useManagers } from '@sayyesschool/frontend/features/managers';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import ManagerForm from '@/components/managers/manager-form';
import ManagersTable from '@/components/managers/managers-table';

export default function ManagersPage({ history }) {
    const [managers, actions] = useManagers();

    const [manager, setManager] = useState();
    const [isFormOpen, toggleFormOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    const createManager = useCallback(data => {
        return actions.createManager(data)
            .then(() => toggleFormOpen(false));
    }, []);

    const deleteManager = useCallback(() => {
        return actions.deleteManager(manager.id)
            .then(() => {
                setManager(null);
                toggleConfirmationDialogOpen(false);
            });
    }, [manager, actions, toggleConfirmationDialogOpen]);

    const handleEdit = useCallback(manager => {
        history.push(manager.url, { edit: true });
    }, [history]);

    const handleDelete = useCallback(manager => {
        setManager(manager);
        toggleConfirmationDialogOpen(true);
    }, [toggleConfirmationDialogOpen]);

    if (!managers) return <LoadingIndicator />;

    return (
        <Page>
            <Page.Header
                title="Менеджеры"
                actions={[{
                    key: 'add',
                    icon: 'add',
                    title: 'Создать',
                    onClick: toggleFormOpen
                }]}
            />

            <Page.Content>
                <UsersSearch params={{ role: 'manager' }} />

                <Page.Section
                    variant="outlined"
                    compact
                >
                    <ManagersTable
                        managers={managers}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                </Page.Section>
            </Page.Content>

            <FormDialog
                form="manager-form"
                title="Новый менеджер"
                open={isFormOpen}
                onClose={toggleFormOpen}
            >
                <ManagerForm
                    id="manager-form"
                    onSubmit={createManager}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Подтвердите действие"
                message={`Вы действительно хотите удалить менеджера ${manager?.fullname}?`}
                open={isConfirmationDialogOpen}
                onConfirm={deleteManager}
                onClose={toggleConfirmationDialogOpen}
            />
        </Page>
    );
}